module.exports = __webpack_public_path__ + "img/dotted-arrow-right.2c3f08f6.svg";